// LOCAL STORAGE GET ITEM
export const getToken = () => localStorage.getItem("tokenProviderPortal");
export const getProviderPortalId = () =>
  localStorage.getItem("providerIdProviderPortal");
export const getChainId = () => localStorage.getItem("chainIdProviderPortal");
export const getTempararyTokenProviderAssist = () =>
  localStorage.getItem("tempararyTokenProviderAssist");
export const getProviderPortalRole = () =>
  localStorage.getItem("ProviderPortalRole");
export const getRole = () => localStorage.getItem("providerPortalSource");
export const getUserName = () => localStorage.getItem("userName");
export const getNetworkUserTypeId = () =>
  localStorage.getItem("networkUserTypeId");
export const getRoleName = () => localStorage.getItem("roleName");
export const getNetworkMenuId = () =>
  JSON.parse(localStorage.getItem("NetworkMenuId"));
export const getShowDefaultMenu = () =>
  localStorage.getItem("showDefaultMenuProviderPortal");
export const getMenus = () =>
  JSON.parse(localStorage.getItem("menusProviderPortal"));
export const validateProviderPayout = () =>
  JSON.parse(localStorage.getItem("validateProviderPayout"));
export const getCampaignsToken = () => localStorage.getItem("campaignsToken");

export const REGISTER_MOBILE_NUMBER = "REGISTER_MOBILE_NUMBER";
export const GET_HOME_PAGE_DETAILS = "GET_HOME_PAGE_DETAILS";
export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const GET_PROFILE_DETAILS = "GET_PROFILE_DETAILS";
export const GET_STAFF_DETAILS = "GET_STAFF_DETAILS";
export const GET_PROFILE_VERIFICATIONS = "GET_PROFILE_VERIFICATIONS";
export const GET_PAYMENT_DETAILS = "GET_PAYMENT_DETAILS";
export const GET_INFRASTRUCTURE_DETAILS = "GET_INFRASTRUCTURE_DETAILS";
export const GET_LOCATION_POSITION = "GET_LOCATION_POSITION";
export const GET_TIME_SLOT = "GET_TIME_SLOT";
export const GET_WORKING_HOURS_SLOT = "GET_WORKING_HOURS_SLOT";
export const IS_PAGE_EDIT = "IS_PAGE_EDIT";
export const GET_STATE_NAME = "GET_STATE_NAME";
export const GET_CITY_NAME = "GET_CITY_NAME";
export const IS_LOADING = "IS_LOADING";
export const GET_PROVIDER_PORTAL_DETAIL = "GET_PROVIDER_PORTAL_DETAIL";
export const VIEW_DETAIL_PAGE = "VIEW_DETAIL_PAGE";
export const GET_CURRENT_PAGE = "GET_CURRENT_PAGE";
export const GET_TOTAL_COUNT = "GET_TOTAL_COUNT";
export const GET_DURATION = "GET_DURATION";
export const GET_VIEW_HISTORY = "GET_VIEW_HISTORY";
export const VIEW_STATUS_BUTTON = "VIEW_STATUS_BUTTON";
export const GET_APPOINMENT_DETAILS = "GET_APPOINMENT_DETAILS";
export const GET_MER_LIBRARY = "GET_MER_LIBRARY";
export const GET_REPORT_DETAILS = "GET_REPORT_DETAILS";
export const GET_APPOINMENT_TIME_SLOT = "GET_APPOINMENT_TIME_SLOT";
export const GET_APPOINMENT_HISTORY = "GET_APPOINMENT_HISTORY";
export const GET_APPOINMENT_UPLOAD_REPORT = "GET_APPOINMENT_UPLOAD_REPORT";
export const IS_SHOW_POPUP = "IS_SHOW_POPUP";
export const GET_USER_ROLE_DETAILS = "GET_USER_ROLE_DETAILS";
export const GET_HELLO_ADMIN_DETAILS = "GET_HELLO_ADMIN_DETAILS";
export const GET_USER_TYPE_DETAILS = "GET_USER_TYPE_DETAILS";
export const GET_ALL_ROLES_DETAILS = "GET_ALL_ROLES_DETAILS";
export const GET_PROVIDER_NAME_DETAILS = "GET_PROVIDER_NAME_DETAILS";
export const GET_CLIENT_NAME_DETAILS = "GET_CLIENT_NAME_DETAILS";
export const GET_APPOINMENT_QUEUE_DETAILS = "GET_APPOINMENT_QUEUE_DETAILS";
export const GET_SKU_TEST_PACKAGES_DETAILS = "GET_SKU_TEST_PACKAGES_DETAILS";
export const GET_HVCHARGESFOR_DETAILS = "GET_HVCHARGESFOR_DETAILS";
export const GET_TESTTYPE_DETAILS = "GET_TESTTYPE_DETAILS";
export const GET_APPOINTMENT_COUNT = "GET_APPOINTMENT_COUNT";
export const GET_CHAIN_NAME = "GET_CHAIN_NAME";
export const GET_PROVIDERS_BY_CHAIN_ID = "GET_PROVIDERS_BY_CHAIN_ID";
export const GET_STATUS_REASON = "GET_STATUS_REASON";
export const GET_FACILITY_TEST = "GET_FACILITY_TEST";
export const GET_PROVIDERLIST_DETAIL = "GET_PROVIDERLIST_DETAIL";
export const GET_PAYOUT_DETAILS = "GET_PAYOUT_DETAILS";
export const GET_USSAGECOVERAGE_DETAILS = "GET_USSAGECOVERAGE_DETAILS";
export const GET_USSAGECOVERAGE_DCPIC_IMAGES =
  "GET_USSAGECOVERAGE_DCPIC_IMAGES";
export const GET_WIDGET_DETAILS = "GET_WIDGET_DETAILS";
export const GET_ADOPTIONANALYSIS_DETAILS = "GET_ADOPTIONANALYSIS_DETAILS";
export const GET_TAGLIST_NETWORK = "GET_TAGLIST_NETWORK";
export const GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT =
  "GET_WHATSAPP_APPOINMENT_UPLOAD_REPORT";
export const GET_WHATSAPP_STATUS_REASON = "GET_WHATSAPP_STATUS_REASON";
export const GET_WHATSAPP_APPOINTMENT_DETAILS =
  "GET_WHATSAPP_APPOINTMENT_DETAILS";
export const GET_PROVIDERDETAILS = "GET_PROVIDERDETAILS";
export const GET_PACKAGE_CREATION = "GET_PACKAGE_CREATION";
export const GET_CLIENTLIST_NETWORK = "GET_CLIENTLIST_NETWORK";
export const GET_FACILITYCATEGORY_NETWORK = "GET_FACILITYCATEGORY_NETWORK";
export const GET_ALLTESTCREATION_NETWORK = "GET_ALLTESTCREATION_NETWORK";
export const GET_PREPARATION_FOR_CHECKUP = "GET_PREPARATION_FOR_CHECKUP";
export const GET_DIAGNOSTICS_DETAILS = "GET_DIAGNOSTICS_DETAILS";
export const GET_TEST_CREATION_DETAIL = "GET_TEST_CREATION_DETAIL";
export const GET_PACKAGE_TAGLIST_NETWORK = "GET_PACKAGE_TAGLIST_NETWORK";
export const GET_PARAMETER_CREATION_DETAILS = "GET_PARAMETER_CREATION_DETAILS";
export const CLEAR_STATE_PAGE = "CLEAR_STATE_PAGE";
export const GET_TESTDETAIL_NEW_PAGE = "GET_TESTDETAIL_NEW_PAGE";
export const GET_TESTDETAIL_UPDATE_PAGE = "GET_TESTDETAIL_UPDATE_PAGE";
export const GET_PACKAGEDETAIL_NEW_PAGE = "GET_PACKAGEDETAIL_NEW_PAGE";
export const GET_PACKAGEDETAIL_UPDATE_PAGE = "GET_PACKAGEDETAIL_UPDATE_PAGE";
export const GET_USSAGECOVERAGE_FILTERS = "GET_USSAGECOVERAGE_FILTERS";
export const GET_ADDITIONAL_FILTER = "GET_ADDITIONAL_FILTER";
export const GET_PAYOUT_COUNT_NETWORK = "GET_PAYOUT_COUNT_NETWORK";
export const GET_CLIENT_LIST = "GET_CLIENT_LIST";
export const GET_MONTH_YEAR = "GET_MONTH_YEAR";
export const GET_PAYOUT_DETAILS_LIST = "GET_PAYOUT_DETAILS_LIST";
export const GET_TOTAL_PROVIDERS_PAYOUT = "GET_TOTAL_PROVIDERS_PAYOUT";
export const GET_TOTAL_APPOINTMENT_PAYOUT = "GET_TOTAL_APPOINTMENT_PAYOUT";
export const GET_FINANCE_QC = "GET_FINANCE_QC";
export const GET_QC_APPROVAL_APPOINTMENT = "GET_QC_APPROVAL_APPOINTMENT";
export const GET_PAYABLE_ACTION = "GET_PAYABLE_ACTION"
export const ADVANCE_PAYOUT_DETAIL = "ADVANCE_PAYOUT_DETAIL"
export const GET_SERVICE_CREATION_DETAIL = "GET_SERVICE_CREATION_DETAIL"
export const GET_FACILITY_DROPDOWNlIST = "GET_FACILITY_DROPDOWNlIST"
export const GET_DETAIL_TYPE = "GET_DETAIL_TYPE"
export const GET_PAYOUT_STATUS = "GET_PAYOUT_STATUS"
export const PARTIAL_TEST_DETAIL = "PARTIAL_TEST_DETAIL"
export const GET_INSURER_TEST_PACKAGE_DETAIL = "GET_INSURER_TEST_PACKAGE_DETAIL"
export const GET_PAYOUT_INSURER_COUNT = "GET_PAYOUT_INSURER_COUNT"
export const GET_INSURER_PAYOUT_DETAIL = "GET_INSURER_PAYOUT_DETAIL"
export const GET_TOTAL_BILLING = "GET_TOTAL_BILLING"
export const GET_TOTAL_CLIENT_DATA = "GET_TOTAL_CLIENT_DATA"
export const GET_INSURER_APPOOINTMENT_DETAIL = "GET_INSURER_APPOOINTMENT_DETAIL"
export const GET_STATUS_QUEUE_DATA = "GET_STATUS_QUEUE_DATA"
export const INS_REMARKS = "INS_REMARKS"
export const GET_PROVIDER_CHAIN = "GET_PROVIDER_CHAIN"
export const GET_PROVIDER_BASED_ON_CHAIN = "GET_PROVIDER_BASED_ON_CHAIN"
export const GET_ADVANCE_PAYMENT_ACTION = "GET_ADVANCE_PAYMENT_ACTION"
export const GET_HISTORY = "GET_HISTORY"
export const HISTORY_COUNT_ROW = "HISTORY_COUNT_ROW"
export const GET_INFORMATION_ACCESS = "GET_INFORMATION_ACCESS";
export const GET_TOTAL_CLOSED_APPOINTMENT="GET_TOTAL_CLOSED_APPOINTMENT"
export const GET_TESTDETAIL_NEW_PAGE_IBU = "GET_TESTDETAIL_NEW_PAGE_IBU";
export const GET_TESTDETAIL_UPDATE_PAGE_IBU = "GET_TESTDETAIL_UPDATE_PAGE_IBU";
export const GET_PACKAGEDETAIL_NEW_PAGE_IBU = "GET_PACKAGEDETAIL_NEW_PAGE_IBU";
export const GET_PACKAGEDETAIL_UPDATE_PAGE_IBU = "GET_PACKAGEDETAIL_UPDATE_PAGE_IBU";
export const GET_PROVIDER_UPLOAD_DOC="GET_PROVIDER_UPLOAD_DOC";
export const GET_PAYOUT_DASH = "GET_PAYOUT_DASH";